import React from 'react'

export default function FinanceCommittee() {
    return (
        <div>FinanceCommittee</div>
    )
}
